import { message } from "antd";
import { makeAutoObservable } from "mobx";
import { loginService, loginViaADFS } from "../../apis/loginApi";
import { LOCAL_STORAGE_TYPE, setLocalStorage } from "../../common/localStorage";
import { globalStores } from "../../GlobalStores";
class LoginStores {
  constructor() {
    makeAutoObservable(this);
  }

  initUserInfo = (responseData, remember = 0) => {
    if (responseData && responseData.token) {
      setLocalStorage(LOCAL_STORAGE_TYPE.USER_TOKEN, responseData.token);
      setLocalStorage(LOCAL_STORAGE_TYPE.USER_REFRESH_TOKEN, responseData.refreshToken);
      setLocalStorage(LOCAL_STORAGE_TYPE.USER_FULL_NAME, responseData.fullname);
      setLocalStorage(LOCAL_STORAGE_TYPE.PARTNER_CODE, responseData.partnerCode);
      setLocalStorage(LOCAL_STORAGE_TYPE.DATE_ONLY_FORMAT, responseData.DATE_ONLY_FORMAT);
      setLocalStorage(LOCAL_STORAGE_TYPE.DATE_TIME_FORMAT, responseData.DATE_TIME_FORMAT);
      setLocalStorage(LOCAL_STORAGE_TYPE.REMEMBER, Number(remember));
      return true;
    }
    return false;
  };

  doLogin = async (formData) => {
    try {
      const { email, password, remember } = formData;
      const response = await loginService(email, password, remember);
      return this.initUserInfo(response?.data, remember);
    } catch (error) {
      message.error(globalStores.t(error?.data?.responseText || "Failed"));
    }
  };

  loginViaADFS = async (code) => {
    try {
      const response = await loginViaADFS(code);
      return response?.data;
    } catch (error) {
      message.error(globalStores.t(error?.data?.responseText || "Failed"));
    }
  };
}

export const loginStores = new LoginStores();
